import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

export default function TermsPage() {
  const [company, setCompany] = useState(null);
  const [terms, setTerms] = useState("");

  useEffect(() => {
    document.title = "Termeni și Condiții | SIMSERV Slobozia";
    api
      .get("/content")
      .then((r) => {
        setCompany(r.data.settings?.company || {});
        setTerms(r.data.settings?.terms_content || "");
      })
      .catch(() => setCompany({}));
  }, []);

  if (company === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">
        <Loader2 className="w-6 h-6 animate-spin" />
      </div>
    );

  return (
    <div className="min-h-screen bg-white" data-testid="terms-page">
      <Navbar company={company} />
      <main className="max-w-3xl mx-auto px-4 sm:px-6 py-10 lg:py-14">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-500 hover:text-[#FF5A1F] mb-6 transition-colors duration-200">
          <ArrowLeft className="w-4 h-4" /> Înapoi la pagina principală
        </Link>

        <h1 className="font-display text-3xl sm:text-4xl font-bold text-[#0F1E36]">Termeni și Condiții</h1>

        {terms ? (
          <div className="article-body mt-8 text-[#1F2937]" dangerouslySetInnerHTML={{ __html: terms }} />
        ) : (
          <p className="mt-8 text-slate-500">Conținutul va fi disponibil în curând.</p>
        )}
      </main>
      <Footer company={company} />
    </div>
  );
}
